import React, { useEffect, useState, useRef } from 'react'
import { validateEmail } from '../assets/utils/validateEmail'
import ForgotPasswordReset from '../assets/Network/POST/ApplyForgotPasswordReset'
import SsoEnabledForUser from '../assets/Network/POST/SsoEnabledForUser'

// Sent by App.java:applyForgotPasswordPOST when the borrower's company is tied to Custom Company
// SSO (OIDC or SAML) -- redirect the browser to the company's IdP login instead of showing the
// "check your email" confirmation step.
const SSO_REDIRECT_PREFIX = 'ssoRedirect:'

export const ForgotPasswordEmailStep = (props) => {
    const [ emailError, setEmailError ] = useState(false)
    const [ emailErrorText, setEmailErrorText ] = useState("")
    const [ email , setEmail ] = useState('')
    const focusRef = useRef(null)
    const [ authToken, setAuthToken ] = useState( window.AN2_CSRF ? window.AN2_CSRF : '')
    const [ssoVisible, setSsoVisible] = useState(false)

    useEffect(() => {
        focusRef.current.focus();
        document.addEventListener("keydown", event => {
            if( event.key === 'Enter' && ssoVisible){
                event.preventDefault()
                return false
            }
          })
    },[])

    const handleEmailChange = (val) => {
        setEmail(val)

        if( validateEmail(val) ){
            SsoEnabledForUser(val, authToken)
            .then( res => {
                if(res){
                    if(res.data === "true" || res.data === true ){
                        setSsoVisible(true)
                    }
                    else if( res.data === false || res.data === 'false' || res.data === 'emptyMail' || res.data === 'illegalMail'){
                        setSsoVisible(false)
                    }
                }
                else{
                    setSsoVisible(false)
                }
            })
        }
        else{
            if( ssoVisible ){
                setSsoVisible(false)
            }
        }
    }

    const handleFormSubmit = (e) => {
        if(!ssoVisible){
            e.preventDefault();
            if ( validateEmail(email) ) {
                ForgotPasswordReset(email, authToken)
                .then((res) => {
                    if ( res.data === 'mailNotExist') {
                        setEmailErrorText("Email address not found.")
                        setEmailError(true)
                    } else if ( typeof res.data === 'string' && res.data.startsWith(SSO_REDIRECT_PREFIX) ) {
                        window.location.href = res.data.substring(SSO_REDIRECT_PREFIX.length)
                    } else {
                        props.setStep(2)
                    }
                })
            } else {
                setEmailErrorText("Please enter a valid email address.")
                setEmailError(true)
            }
        }else{
            e.preventDefault();
            return false
        }
    }

    return (
        <div>
            <form noValidate className="floify-login-form" id="forgot-password-form" onSubmit={ (e) => handleFormSubmit(e) }>
                <div className="login-inner-padded">
                    <h1 className="h3" id="modal-title">Forgot Password?</h1>
                    <p>Enter the email address associated with your account and we’ll send you a link to reset your password.</p>
                </div>
                <div className="login-popup-form">
                    <div className="login-inner-padded">
                        { emailError &&
                            <div className="error">{emailErrorText}</div>
                        }
                        <div className={`emailInput flex align-items-center justify-space-between ${emailError ? `errorHighlight` : ``} `}>
                            <label htmlFor="email">Email</label>
                            <input ref={focusRef} autoComplete="email" aria-label="Email Address" className="existingUserEmail" type="email" name="email" value={email} onChange={ (e) => handleEmailChange( e.target.value ) }></input>
                            <div id="ssoEnabledMsg" className={ssoVisible ? 'viz' : ''}><p>Contact your Microsoft administrator to acquire or reset your password.</p><div className="rightArrow"></div></div>
                        </div>
                    </div>
                    <div className={`login-modal-footer`}>
                        <div className={`modal-buttons-container login-inner-padded flex justify-space-between align-items-center ${ssoVisible ? 'ssoViz' : ''}`}>
                            <div className="login-button-wrapper">
                                <button id="login-next-btn" name="Next" className="lp-button buttonHover" type="submit" onClick={ (e) => handleFormSubmit(e) }>Send Reset Link</button>
                            </div>
                            <a className="forgot-password" href="/">Back to Login</a>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}